<template>
  <div>
    <!-- 支付弹窗 -->
    <poppayment
      :dialogname.sync="dialogname"
      :req_data="j_req"
      :api_goodsdata="api_goodsdata"
      @close="clickClose"
    />
    <!-- 半屏弹窗vip -->
    <pullupvip
      :dialogname.sync="dialogname"
      :req_data="j_req"
      :api_goodsdata="api_goodsdata"
      @close="clickClose"
      @open="clickOpen"
      @selectgood="clickSelectGood"
    />
  </div>
</template>
<script>
import poppayment from "./comp/poppayment/main.vue";
import pullupvip from "./comp/pullupvip/main.vue";
import {getH5Membergoods, getH5Memberdetail} from "./js/api.js";
import {getDeepVal} from "@/assets/fe_js/common/base/fn/object";
import {ua, qs} from "@/assets/fe_js/common/base/fn/browser";
import {toast} from "@/assets/fe_js/common/base/fn/message";
export default {
    name: "Paymentpop",
    components: {
        poppayment,
        pullupvip,
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        req: {
            type: Object,
            default: function () {
                return {};
            }
        },
    },
    data () {
        return {
            dialogname      : "",
            api_goodsdata   : {},
            current_good    : {},
        };
    },
    computed: {
        j_req(){
            let v =  {
                action          : this.req.action || "",    //1.poppayment[直接付] 2.pullupvip[拉起vip半屏] 3.pullupkkb[拉起kkb半屏]
                //接口所需字段
                third_activity  : this.req.third_activity || "",    //string 活动ID
                good_type       : this.req.good_type || 0,     //int 1.kkb 2.vip
                good_id         : this.req.good_id || 0,     //int 76
                coupon_id       : this.req.coupon_id || "",    //string '5733161272790585360' 优惠券id
                coupon_type     : this.req.coupon_type || 0,     //int 0:使用第一个, 1:使用最大的优惠券 2:待扩充
                comic_id        : this.req.comic_id || 0,     //int 漫画id
                topic_id        : this.req.topic_id || 0,     //int 专题id
                source_type     : this.req.source_type || 0,     //int 1：签到，2：皇冠，3：作品，4：礼包
                invite_code     : this.req.invite_code || "",    //string 拉新活动时候会有邀请码
                //埋点所需字段
                cps             : this.req.cps || "",    //string 下单接口时要传递的字段，也用作埋点上报
                trigger_page    : this.req.trigger_page || "",    //埋点属性TriggerPage
                origin          : this.req.origin || "",    //埋点属性EntranceName
                //回掉地址
                redirect_url    : this.req.redirect_url || "",    //支付成功之后想跳回的h5地址
                //小程序
                bind_phone      : this.req.bind_phone || 0,     //百度小程序支付前验证是否需要绑定手机号，默认：0 不绑定
            };
            return v;
        }
    },
    watch: {
        visible:{
            handler(val, oldVal){
                this.init();
            },
            deep:true
        },
    },
    methods:{
        init(){
            if (this.visible) {
                if (!this.checkPropsParam("view")) {
                    this.setVisbleFalse();
                    return null;
                }
                if (this.j_req.action == "poppayment") {
                    this.getDetail();
                } else {
                    this.getMember();
                }
            } else {
                this.closeDialog();
            }
        },
        openDialog(dialogname){
            this.dialogname = dialogname;
            this.sendMessageBefore(1,"打开"+dialogname);
        },
        closeDialog(){
            this.dialogname = "";
            // this.sendMessageBefore(2,'关闭')
        },
        clickOpen(dialogname){
            this.openDialog(dialogname);
        },
        clickClose(dialogname) {
            if (this.dialogname == "dialog-poppayment-child") {
                this.dialogname = "dialog-"+this.j_req.action;
            } else {
                this.$emit("update:visible", false);
                this.sendMessageBefore(2,"关闭");
            }
        },
        setVisbleFalse(dialogname) {
            if (this.visible) {
                this.$emit("update:visible", false);    
            }
        },
        clickSelectGood(good) {
            this.j_req.good_id = good.id;
            this.j_req.coupon_id = good.couponid;
        },
        checkPropsParam(mode){
            if (
                this.j_req.action !== "poppayment" && 
                this.j_req.action !== "pullupvip" &&
                this.j_req.action !== "pullupkkb" 
            ) {
                this.sendMessageBefore(-1, "请输入正确的action");
                return false;
            }

            if (this.j_req.good_type !==1 && this.j_req.good_type !==2) {
                this.sendMessageBefore(-1, "请输入正确的good_type");
                return false;
            }

            switch(this.j_req.action){
            case "poppayment":
                if (!(this.j_req.good_id > 0)) {
                    this.sendMessageBefore(-1, "请输入正确的good_id");
                    return false;
                }
                break;
            }
            return true;
        },
        checkLogin(){
            if (getDeepVal(this.api_goodsdata,"user.id",0) == 0) {
                this.sendMessageBefore(401, "请登录");
                return false;
            }
            return true;
        },
        sendMessageBefore(code, message, data={}){
            if (code == -1) {
                toast("支付遇到问题~");
                this.setVisbleFalse();
            }
            if (code == 401) {
                this.setVisbleFalse();
            }
            this.sendMessage({code:code, data:data, message:message});
        },
        sendMessage(res){
            this.$emit("res", res);
        },
        getParamList(){
            return {
                third_activity  : this.j_req.third_activity || "",
                code            : "",//微信code，为了获取openid
                env             : qs["env"] || "",
            };
        },
        getParamDetail(){
            return {
                third_activity              : this.j_req.third_activity || "",
                good_id                     : this.j_req.good_id || 0,
                non_iap_supported_device    : false,//是否越狱设备，true表示是
                non_iap_supported           : 0,//运营位是否支持越狱，1表示支持
            };
        },
        getDetail() {
            Promise.all([
                getH5Memberdetail(this.getParamDetail()),
                getH5Membergoods(this.getParamList())
            ]).then((res) => {
                try {
                    if (res[0].code !== 200) {
                        if (res[0].code == 401) {
                            this.checkLogin();
                            return null;
                        }
                        this.sendMessageBefore(-1, "getDetaila:["+res[0].code+res[0].message+"]");
                        return null;
                    }
                    res[1].data.members[0].pay_types = res[0].data.pay_types;
                    let v = {
                        ...res[0].data.member_good,
                        ...res[0].data.member_good.price
                    };
                    if (v.renew_type == 1) {
                        res[1].data.members[0].renew_goods = [];
                        res[1].data.members[0].recharge_goods = [v];
                    } else {
                        res[1].data.members[0].renew_goods = [v];
                        res[1].data.members[0].recharge_goods = [];
                    }
                    //v1/pay/member_good/h5_list request_id字段没有值
                    //v1/vip/member_good/list_h5 才有值
                    res[1].data.request_id = res[0].data.request_id;

                    this.api_goodsdata = res[1].data;
                    this.openDialog("dialog-"+this.j_req.action);
                } catch(error){
                    this.sendMessageBefore(-1, "getDetailb:["+error+"]");
                }
            }).catch(error => {
                this.sendMessageBefore(-1, "getDetailc:["+error+"]");
            });
        },
        getMember(){
            let f = false;
            if(this.api_goodsdata.members) {
                if (!this.checkLogin()) {
                    return null;
                }
                if (!f) {
                    this.openDialog("dialog-"+this.j_req.action);
                    f = true;
                }
            }
            getH5Membergoods(this.getParamList())
                .then(res => {
                    let {code, data={}, message=""} = res;
                    if (code !== 200) {
                        this.sendMessageBefore(-1, "getMembera:["+code+message+"]");
                        return null;
                    }
                    this.api_goodsdata = data;
                    if (!f) {
                        this.openDialog("dialog-"+this.j_req.action);    
                    }
                })
                .catch(error => {
                    this.sendMessageBefore(-1, "getMemberb:["+error+"]");
                });
        },
        // 父组件调用，可以预取或刷新数据
        refresh() {
            setTimeout(() => {
                getH5Membergoods(this.getParamList())
                    .then(res => {
                        let {code, data={}, message=""} = res;
                        this.api_goodsdata = data;
                        this.sendMessage(res);
                    })
                    .catch(error => {
                        this.sendMessageBefore(-1, "refresh-pullupvip:["+error+"]");
                    });
            },0);
        },
    }
};
</script>
<style lang="scss">
.flex_layout {display: -webkit-box;display: -webkit-flex;display: flex; }
.flex_wrap{-webkit-flex-wrap:wrap;flex-wrap:wrap;}
.flex_flexDirection_column{-webkit-flex-direction:column;flex-direction:column;}
.flex_alignContent_center{-webkit-align-content: center;align-content: center; }
.flex_x_start{-webkit-justify-content: flex-start;justify-content: flex-start;-webkit-box-pack: flex-start;}
.flex_x_end{-webkit-justify-content: flex-end;justify-content: flex-end;-webkit-box-pack: flex-end;}
.flex_x_spacearound{-webkit-justify-content: space-around;justify-content: space-around;-webkit-box-pack: space-around;}
.flex_x_spacebetween{-webkit-justify-content: space-between;justify-content: space-between;-webkit-box-pack: justify;}
.flex_x_center{-webkit-justify-content: center;justify-content: center;-webkit-box-pack: center;}
.flex_y_center{-webkit-box-align: center;-webkit-align-items: center;align-items: center; }
.flex_y_stretch{-webkit-box-align: stretch;-webkit-align-items: stretch;align-items: stretch; }
.flex_y_start{-webkit-box-align: flex-start;-webkit-align-items: flex-start;align-items: flex-start; }
.flex_y_end{-webkit-box-align: flex-end;-webkit-align-items: flex-end;align-items: flex-end; }
.flex_xy_center{-webkit-box-align: center;-webkit-align-items: center;align-items: center; -webkit-justify-content: center;justify-content: center;-webkit-box-pack: center;}
/*auto (1 1 auto) 和 none (0 0 auto)*/
.flexitem_flex_auto {-webkit-box-flex: 1;-webkit-flex: 1;flex: auto;}
.flexitem_flex_none {-webkit-box-flex: 0;-webkit-flex: 0;flex: none;}
.flexitem_flexshrink_0 {-webkit-flex-shrink: 0;flex-shrink: 0;}
.flexitem_flexgrow_0 {-webkit-flex-grow: 0;flex-grow: 0;}
.flexitem_line{-webkit-box-flex: 1;-webkit-flex: 1;flex: 1;min-width: 0;}
.flexitem_y_center{-webkit-align-self: center;align-self: center;}
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.fade-enter-active {
    -webkit-animation: bounce-in 0.3s ease forwards;
    animation: bounce-in 0.3s ease forwards;
}
.fade-leave-active {
    -webkit-animation: bounce-in 0.3s ease forwards reverse;
    animation: bounce-in 0.3s ease forwards reverse;
}
@-webkit-keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/web/pay/action.vue